import { instance } from './request.utility';

/**
 * Transform hits from new API format to legacy Algolia format
 */
const transformHits = (hits, indexId) => {
  const keyMap = {
    lab_email: 'email',
    lab_projects: 'project',
  };
  const valueKey = keyMap[indexId] || 'value';

  return hits.map(hit => ({
    ...hit,
    objectID: hit._id,
    [valueKey]: hit.value,
  }));
};

export const autoComplete = (value = '', setLoading, page = 0, _clinic_id, indexId, callback, signal) => {
  setLoading(true);

  return instance
    .get(`/lab/autocomplete/${indexId}`, { params: { q: value, page, limit: 10 }, signal })
    .then(response => {
      const { hits, page } = response.data;
      callback({ hits: transformHits(hits, indexId), page });
    })
    .catch(err => {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      console.log('err', err.message);
    })
    .finally(() => {
      setLoading(false);
    });
};

export const autoCompleteInput = (value = '', _clinic_id, indexId, callback, signal) => {
  return instance
    .get(`/lab/autocomplete/${indexId}`, { params: { q: value, limit: 10 }, signal })
    .then(response => {
      const { hits } = response.data;
      callback({ hits: transformHits(hits, indexId) });
    })
    .catch(err => {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;
      console.log('err', err.message);
    });
};
